import ThumbnailTextItem from './ThumbnailTextItem';
import { ThumbnailTextItemProps, ThumbnailTextItemValueProps } from './types';

export type { ThumbnailTextItemProps, ThumbnailTextItemValueProps };
export default ThumbnailTextItem;
